import { ITooltipAngularComp } from '@ag-grid-community/angular';
import { ITooltipParams } from '@ag-grid-community/core';
import { Component } from '@angular/core';
import { GridModalComponent } from '@app/core/components/grid/grid.decorators';
import { DataTaskService } from '@app/core/services/data-task.service';

@GridModalComponent('ProductsUnitTooltipComponent')
@Component({
    selector: 'tt-products-unit-tooltip',
    templateUrl: './products-unit-tooltip.component.html',
    styleUrls: ['./products-unit-tooltip.component.css'],
})
export class ProductsUnitTooltipComponent implements ITooltipAngularComp {
    text = '';

    constructor(private datatask: DataTaskService) {}

    private async getText(data: any) {
        if (!!data && 'prodsize_keyno' in data) {
            this.text = (await this.datatask.Post(588, data))[0].exampledata;
        }
    }

    agInit(params: ITooltipParams<any, any, any>): void {
        this.getText(params.data);
    }
}
